import { AuthData } from "../types/steps/auth"

const STORAGE_KEY = "comfortkino-auth-draft"

export type AuthUserFormDraft = {
    form: {
        lastname: string
        firstname: string
        patronymic: string
        birthday: string
        email: string
    }
    checked: {
        personalData: boolean
        privacy: boolean
        terms: boolean
    }
}

export type AuthDraft = {
    stack: string[]
    data: Partial<AuthData>
    userForm?: AuthUserFormDraft
    modalBackground?: {
        pathname: string
        search: string
        hash: string
    }
}

export function loadAuthDraft(): AuthDraft | null {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY)
        if (!raw) return null
        return JSON.parse(raw) as AuthDraft
    } catch {
        return null
    }
}

export function saveAuthDraft(draft: AuthDraft): void {
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(draft))
    } catch {
        /* ignore quota errors */
    }
}

export function patchAuthDraft(patch: Partial<AuthDraft>): void {
    const current = loadAuthDraft() ?? { stack: ["user"], data: {} }
    saveAuthDraft({ ...current, ...patch })
}

export function clearAuthDraft(): void {
    try {
        sessionStorage.removeItem(STORAGE_KEY)
    } catch {
        /* ignore */
    }
}
